export const getLimoTripTitle = (destination) => {
  if (!destination) {
    return 'Trip - Limo';
  }
  if (destination.toLowerCase() === 'limo') {
    return `Trip - ${destination}`;
  }
  return `Trip Limo - ${destination}`;
};
export default getLimoTripTitle;

export const convertLocaleToUpperCase = (paramsLocale) => {
  const [lang, country] = paramsLocale.split('-');
  return `${lang}-${country?.toUpperCase()}`;
};

export const splitIcons = (trip) => trip?.type?.split(',')?.map((type) => type?.toLowerCase());

export const getTripIcons = (trip) => {
  const icons = [...splitIcons(trip)];
  return [...new Set(icons)];
};

export const isToggleEnabled = (data, locale, toggleName) => {
  if (Object.keys(data).length > 0) {
    const toggleData = Object.entries(data)[0][1];
    return toggleData[locale][toggleName];
  }
  return false;
};
